import React from 'react';
import Header from '../features/header';
import './layout2.css';

// TODO: Will use layouts and slots
const Layout2: React.FC<{
  breadcrumbsSlot: React.ReactNode,
  contentSlot: React.ReactNode,
  topSlot: React.ReactNode,
  leftSlot: React.ReactNode,
  rightSlot1: React.ReactNode,
  rightSlot1Hide?: boolean,
  rightSlot2?: React.ReactNode,
  rightSlot2Hide?: boolean,
  dialogSlot?: React.ReactNode,
  dialogSlotShow?: boolean,
}> = ({
  breadcrumbsSlot,
  contentSlot,
  topSlot,
  leftSlot,
  rightSlot1,
  rightSlot1Hide,
  rightSlot2,
  rightSlot2Hide,
  dialogSlot,
  dialogSlotShow,
}) => (
  <>
    <div className='lyt2-header'>
      <Header />
    </div>
    <main className='lyt2-main'>
      <div className='lyt2-breadcrumbs'>
        {breadcrumbsSlot}
      </div>
      <div className='lyt2-top-bar'>
        {topSlot}
      </div>
      <div className='lyt2-main-content'>
        <div className='lyt2-main-left'>
          <div className='lyt2-main-left-inner'>
            {leftSlot}
          </div>
        </div>
        <div className='lyt2-main-center'>
          <div className='lyt2-main-center-inner'>
            {contentSlot}
          </div>
        </div>
        {
          !rightSlot1Hide
            ? <div className='lyt2-main-right'>
                <div className='lyt2-main-right-inner'>
                  {rightSlot1}
                </div>
              </div> : null
        }
        {
          !rightSlot2Hide
            ? <div className='lyt2-main-right'>
                <div className='lyt2-main-right-inner'>
                  {rightSlot2}
                </div>
              </div> : null
        }
      </div>
      <div className='lyt2-footer-bar'></div>
    </main>
    {dialogSlotShow && dialogSlot ? <div className='lyt2-mask'>{dialogSlot}</div> : null}
  </>
);

export default Layout2;
